import ContractorRegistrationApiService from "../api/contractorRegistration";
import { normalizeDigits } from "./formatters";

const toAsciiDigits = (value) => {
  if (value == null || value === "") return null;
  return normalizeDigits(String(value))?.trim() || null;
};

const pick = (obj, ...keys) => {
  for (const key of keys) {
    if (obj && obj[key] !== undefined) return obj[key];
  }
  return undefined;
};

const looksTechnicalMessage = (message = "") => {
  const text = String(message).toLowerCase();
  return [
    "invalid attempt to call",
    "reader is closed",
    "object reference",
    "sqlexception",
    "stack trace",
    "inner exception",
  ].some((token) => text.includes(token));
};

const sanitizeAvailabilityMessage = (
  message,
  fallback = "خطا در استعلام اطلاعات. لطفاً دوباره تلاش کنید."
) => {
  const normalized = String(message || "").trim();
  if (!normalized) return fallback;
  if (looksTechnicalMessage(normalized)) return fallback;
  return normalized;
};

const unwrapAvailability = (response) => {
  const payload =
    response &&
    (Object.prototype.hasOwnProperty.call(response, "isSuccess") ||
      Object.prototype.hasOwnProperty.call(response, "IsSuccess"))
      ? response
      : response?.data ?? response;
  const isSuccess = pick(payload, "isSuccess", "IsSuccess");
  if (!isSuccess) {
    return {
      ok: false,
      message: sanitizeAvailabilityMessage(
        pick(payload, "message", "Message"),
        "استعلام ثبت‌نام ناموفق بود."
      ),
      conflicts: [],
    };
  }

  const availability = pick(payload, "data", "Data") ?? payload;
  const isAvailable = pick(availability, "isAvailable", "IsAvailable");
  if (isAvailable) {
    return { ok: true, message: null, conflicts: [] };
  }

  return {
    ok: false,
    message: sanitizeAvailabilityMessage(
      pick(availability, "message", "Message"),
      "اطلاعات وارد شده قبلاً ثبت شده است."
    ),
    conflicts: pick(availability, "conflicts", "Conflicts") || [],
  };
};

export const buildContractorRegistrationInquiryPayload = (formData) => ({
  registrationType: formData.registrationType,
  nationalCode: toAsciiDigits(formData.nationalCode),
  mobile: toAsciiDigits(formData.mobile),
  email: formData.email?.trim() || null,
  companyNationalId:
    formData.registrationType === "legal"
      ? toAsciiDigits(formData.companyNationalId)
      : null,
});

export const inquiryContractorRegistration = async (formData) => {
  const response = await ContractorRegistrationApiService.inquiryAvailability(
    buildContractorRegistrationInquiryPayload(formData)
  );
  return unwrapAvailability(response);
};

export const mapAvailabilityConflictsToErrors = (conflicts = []) => {
  const errors = {};
  conflicts.forEach((conflict) => {
    if (conflict?.field && conflict?.message && !errors[conflict.field]) {
      errors[conflict.field] = sanitizeAvailabilityMessage(
        conflict.message,
        "این مقدار قبلاً ثبت شده است."
      );
    }
  });
  return errors;
};
